$mol_plot_ruler_vert $mol_plot_ruler
	title_align \end
	label_align \end
	title_pos_y \14
	label_pos_x* <= title_pos_x
	background_height \100%
	background_width <= title_pos_x
